export const Voslogicimages = {
  logo: require("../assets/images/logo.png"),
  burguricon: require("../assets/images/icon.png"),
  artifical: require("../assets/images/artifical.png"),

  aribot: require("../assets/images/aibot.png"),
  automate: require("../assets/images/automated.png"),
  aviability: require("../assets/images/availability.png"),
  easyconfig: require("../assets/images/easyconfig.png"),

  herowhatwedo: require("../assets/images/herowhatwedo.png"),
  hereoforyourself: require("../assets/images/here-for-yourself.png"),
  homehero: require("../assets/images/homeheroo.png"),
  realtimemange: require("../assets/images/realtimemangement.png"),

  predictive: require("../assets/images/predictive.png"),
  ivr: require("../assets/images/ivr.png"),
  called: require("../assets/images/called.png"),
  ring: require("../assets/images/ringless.png"),

  soundwave: require("../assets/images/soundwave.png"),
  footerglogo: require("../assets/images/footer-logo.png"),

  // image for compare slider
  voice: require("../assets/images/voice.png"),
  statement: require("../assets/images/staiment.png"),
  intelligent: require("../assets/images/intelligent.png"),
  scal: require("../assets/images/scal.png"),
  conver: require("../assets/images/conv.png"),
  complte: require("../assets/images/comp.png"),
  contorl: require("../assets/images/contorl.png"),

  artboard1: require("../assets/images/Artboard1.png"),
  artboard2: require("../assets/images/Artboard2.png"),
  artboard3: require("../assets/images/Artboard3.png"),
  datadrive: require("../assets/images/datadrive.png"),
  tabswave: require("../assets/images/wavesbg.png"),

  // faq
  faqimg: require("../assets/images/faq-image2.png"),
  faq1: require("../assets/images/faq1.png"),
  faq2: require("../assets/images/faq2.png"),

  // compaure logo
  callmarker: require("../assets/images/callmarker-logo.png"),
  loogolarge: require("../assets/images/logo-light-large.png"),
  brigth: require("../assets/images/brigth.png"),
  vocodia: require("../assets/images/vocodia.png"),

  //
  mask: require("../assets/images/mask.png"),
  playicon: require("../assets/images/playicon.png"),
};
